import { render, staticRenderFns } from "./vFormSEPARATOR.vue?vue&type=template&id=1a861c33&scoped=true&"
import script from "./vFormSEPARATOR.vue?vue&type=script&lang=js&"
export * from "./vFormSEPARATOR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a861c33",
  null
  
)

export default component.exports